import React, { Component } from 'react';
import Select from 'react-select';
import {
    Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb,
    Input, Dropdown, MenuItem
} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import moment from 'moment';

import CashFormatter from '../Common/cashFormatter';
import { ROOT_URL } from '../../actions/root_url';

const { Selectors } = Data;

export class AltonChildModal extends Component {
    constructor() {
        super();
        this.state = {

            agentList: {
                rows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            // rows: [],
            // selectedRows: null,
            // editedRows: [],
            // filters: {},
        }
    }

    componentDidMount() {
        let { agentList } = this.state;
        axios
            .get(
                `${ROOT_URL}v1/product/child_products/${this.props.altonSelectedProd}`,
                // `${ROOT_URL}v1/product/child_products/2497`,
                {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                })
            .then(response => {
                agentList.rows = response.data;
                this.setState({ agentList });
                // this.setState({rows: response.data});
            }, err => {
                if (err.data) {
                    alert(err.data);
                } else {
                    alert("Server issue detected, please contact admin.");
                }
            });
        // let {selectedBatch} = this.state;
        // this.setState({ selectedBatch });
    }

    componentWillReceiveProps(nextProps) {
    }



    renderAgentTable() {
        const getRows = () => Data.Selectors.getRows(this.state.agentList);

        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            const agentList = Object.assign({}, this.state.agentList, { sortColumn, sortDirection });
            this.setState({ agentList });
        };

        const handleFilterChange = (filter) => {
            const newFilters = Object.assign({}, this.state.agentList.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const agentList = { ...this.state.agentList, filters: newFilters };
            this.setState({ agentList });
        };

        const handleClearFilters = () => {
            const agentList = { ...this.state.agentList, filters: {} };
            this.setState({ agentList });
        };

        const columns = [
            {
                key: 'related_name',
                name: <Translate value="related_name" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 290,
            },
            {
                key: 'related_refnum',
                name: <Translate value="related_refnum" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 130,
            },
            {
                key: 'convert_number',
                name: <Translate value="convert_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 130,
                // formatter: ({ value }) => (
                //     <div>
                //       { value ? "true" : "false" }
                //     </div>
                //   ),
            },
        ]

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '550px', marginLeft: '25px' }}>
                        <ReactDataGrid
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={300}
                            rowHeight={25}
                            headerRowHeight={45}
                            toolbar={<Toolbar enableFilter />}
                            onGridSort={handleGridSort}
                            onAddFilter={handleFilterChange}
                            onClearFilters={handleClearFilters}

                        //   onRowUpdated={handleRowUpdated}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
            //   selectedBatch,
        } = this.state;

        return (
            <div>
                <Row>
                    <Col className="text-center">
                        <span>{this.renderAgentTable()}</span>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AltonChildModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/AltonChildModal.jsx